module.exports = __webpack_public_path__ + "img/caretArrowUp_b.b01a75bb.svg";